export default {
  data() {
    return {};
  },

  methods: {
    // 下拉过滤
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    // tree select筛选
    filterTreeNode(input, treeNode) {
      const { data } = treeNode;
      const { props } = data;
      const text = (props.name || props.title || props.label).toLowerCase();
      return text.indexOf(input.toLowerCase()) >= 0;
    },
  },
};
